import React from "react";
import Layout from "../components/Layout";
import homeLogo from "../assets/images/Home.jpg";
import homeLogoRmBg from "../assets/images/homeLogoRmBg.png";
import intergrate from "../assets/images/Integrates.jpg";
import homeMiddle from "../assets/images/img1.svg";
import "./Home.css";
import Removebg from "../components/Removebg";
import { dataShow } from "../data/data";
import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import LiveShow from "../components/LiveShow";
import { dataHomeDemo } from "../data/data";
import { useHistory } from "react-router-dom";
import { useUserAuth } from "../context/UserAuthContext";
import Info from "../components/Info";
export default function Home() {
  const [itemShow, setItemShow] = useState(dataShow[0]);
  const [active, setActive] = useState("People");
  const hisory = useHistory();
  const { loginInfo, logoutInfo, setLoginInfo, setLogoutInfo } = useUserAuth();

  const handlerClick = (item) => {
    setItemShow(dataShow.filter((x) => x.name === item.name)[0]);
    setActive(item.name);
  };

  return (
    <Layout>
      {loginInfo && (
        <Info
          msg={"Signed in successfully."}
          handleInfo={() => {
            setLoginInfo(false);
          }}
        />
      )}
      {logoutInfo && (
        <Info
          msg={"Signed out successfully."}
          handleInfo={() => {
            setLogoutInfo(false);
          }}
        />
      )}
      <div className="home-content">
        <div className="home-left">
          <h1>Remove Image Background</h1>
          <p>
            100% Automatically and <strong>Free</strong>
          </p>
          <div className="container-img">
            <img src={homeLogo} alt="#" />
          </div>
        </div>

        <div className="home-right">
          <div className="home-ctn-right">
            <div className="home-left-icon">
              <svg
                data-v-82a97972=""
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 22 16"
                height="16mm"
                width="22mm"
              >
                <path
                  data-v-82a97972=""
                  d="M.787 6.411l10.012 5.222a.437.437 0 0 0 .402 0l10.01-5.222a.434.434 0 0 0 .186-.585.45.45 0 0 0-.186-.187L11.2.417a.441.441 0 0 0-.404 0L.787 5.639a.439.439 0 0 0-.184.588.453.453 0 0 0 .184.184z"
                  fill="#DDDFE1"
                ></path>
                <path
                  data-v-82a97972=""
                  d="M21.21 9.589l-1.655-.864-7.953 4.148a1.31 1.31 0 0 1-1.202 0L2.444 8.725l-1.657.864a.437.437 0 0 0-.184.583.427.427 0 0 0 .184.187l10.012 5.224a.437.437 0 0 0 .402 0l10.01-5.224a.434.434 0 0 0 .186-.586.444.444 0 0 0-.186-.184z"
                  fill="#EDEFF0"
                ></path>
              </svg>
            </div>
            <form>
              <button
                onClick={() => {
                  hisory.push("/upload");
                }}
              >
                <i className="fa fa-upload" aria-hidden="true"></i>
                Try now
              </button>
              <p>or drop file</p>
            </form>
          </div>
          <div className="home-btn-bottom">
            <p>Paste image or URL ctrl + v</p>
          </div>
          <div className="try-img-demo">
            <div className="list-imgs">
              <p>No image? Try one of these:</p>
              <div className="thumbnails">
                {dataHomeDemo.map((item) => {
                  return <img key={item.id} src={item.thumbnail} alt="#" />;
                })}
              </div>
            </div>
            <p>
              By uploading an image or URL you agree to our Terms of Service.
              This site is protected by hCaptcha and its Privacy Policy and
              Terms of Service apply.
            </p>
          </div>
        </div>

        <div className="home-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="88.209"
            height="98.922"
            viewBox="0 0 88.209 98.922"
            class="home-start-upload-arrow sprite sprite-arrow"
          >
            <path
              d="M79.79,93.774l-2.981,1.17-1.641.6-3.195,1.112c-4.176,1.41-8,2.525-11.282,3.3-6.561,1.548-10.941,1.733-11.585.189s2.569-4.527,8.285-8.1c2.425-1.516,5.322-3.141,8.544-4.8A57.408,57.408,0,0,1,48.179,81.8,60.135,60.135,0,0,1,38.5,75.7,58.62,58.62,0,0,1,29.7,67.015,61.125,61.125,0,0,1,18.809,46.249a68.736,68.736,0,0,1-3.02-18.388A53.086,53.086,0,0,1,15.95,20.8c.086-1.034.147-1.993.287-2.873s.3-1.682.466-2.4c.65-2.878,1.407-4.432,2.244-4.431s1.676,1.547,2.473,4.275c.2.682.4,1.438.589,2.264l.7,2.662c.488,1.9.9,4.068,1.571,6.4a110.967,110.967,0,0,0,5.058,15.825,66.468,66.468,0,0,0,9.768,16.843,60.866,60.866,0,0,0,6.913,7.144,67.012,67.012,0,0,0,7.545,5.506,78,78,0,0,0,14.7,6.927c.152.054.3.1.446.155-2.663-3.208-4.966-6.216-6.789-8.867-3.819-5.554-5.579-9.57-4.372-10.73s5.15.754,10.551,4.788c2.7,2.017,5.765,4.563,9.034,7.52L79.622,74.1l1.268,1.2,2.267,2.26c3.354,3.371,6.86,6.955,10.378,10.614C88.855,90.127,84.209,92.018,79.79,93.774Z"
              transform="translate(-16.963 0.383) rotate(-7)"
              fill="currentColor"
            ></path>
          </svg>
        </div>
      </div>

      <div className="home-liveshow">
        <LiveShow />
      </div>

      <div class="home-middle">
        <div> <img src={homeMiddle} alt="#" /></div>
        <div class="home-text" style={{ color: "rgb(69, 69, 69)" }}>
          <h2>
            Remove backgrounds 100% automatically in 5 seconds with one click
          </h2>
          <p>
            Thanks to remove.bg's clever AI, you can slash editing time - and
            have more fun!
          </p>
          <p>
            No matter if you want to make a background transparent (PNG) or add
            a white background to a photo - you can do all this and more with
            remove.bg.
          </p>
        </div>
      </div>


      <div className="home-demo">
        <h1>Stunning Quality</h1>
        <ul>
          {dataShow.map((item) => {
            return (
              <li
                key={item.id}
                onClick={() => handlerClick(item)}
                className={active === item.name ? "active-tab" : ""}
              >
                {item.name}
              </li>
            );
          })}
        </ul>
        <div className="home-img-container">
          {<Removebg imgOrigin={itemShow.src} imgRmBg={itemShow.srcRmBg} />}
        </div>
      </div>

      <div className="home-intergrate">
       <div> <img src={intergrate} alt="#" /></div>
        <div className="home-intergrate-content">
          <h2>Integrates with your Software Workflow</h2>
          <p>
            We've built tools and plugins for some of the most popular design
            programs, eCommerce sites and computer environments. To bring more
            digital efficiency to your own workflow, use our API!
          </p>
          <div className="home-intergrate-link">
            <ul>
              <li className="intergrate-btn" to="">
                All Plugins & Downloads <i class="fa-solid fa-angle-right"></i>
              </li>
              <li className="intergrate-btn" to="">
                API Documentation <i class="fa-solid fa-angle-right"></i>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="home-bottom">
        <h2>Ramp up the creativity - and efficiency!</h2>
        <p>
          Whether you want to make a mind-blowing greetings card for your bestie
          or to power through thousands of car photos in next to no time,
          remove.bg makes it happen.
        </p>
        <div className="home-bottom-link">
          <div>
            <ul>
              <li className="home-bottom-link-btn" to="">
                for Individuals <i class="fa-solid fa-angle-right"></i>
              </li>
              <li className="home-bottom-link-btn" to="">
                for Photographers <i class="fa-solid fa-angle-right"></i>
              </li>
              <li className="home-bottom-link-btn" to="">
                for Ecommerce <i class="fa-solid fa-angle-right"></i>
              </li>
              <li className="home-bottom-link-btn" to="">
                for Media <i class="fa-solid fa-angle-right"></i>
              </li>
            </ul>
          </div>
          <div>
            <ul>
              <li className="home-bottom-link-btn" to="">
                for Marketing <i class="fa-solid fa-angle-right"></i>
              </li>
              <li className="home-bottom-link-btn" to="">
                for Car Dealerships <i class="fa-solid fa-angle-right"></i>
              </li>
              <li className="home-bottom-link-btn" to="">
                for Developers <i class="fa-solid fa-angle-right"></i>
              </li>
              <li className="home-bottom-link-btn" to="">
                for Developers <i class="fa-solid fa-angle-right"></i>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </Layout>
  );
}
